import * as nationalities from 'i18n-nationality';
import deNationalityLocale from 'i18n-nationality/langs/de.json';
import enNationalityLocale from 'i18n-nationality/langs/en.json';

// Locales werden lazy registriert, damit die Utility auch aufgerufen werden
// kann, bevor PersonalDataComponent.ngOnInit die Registrierung uebernommen hat
// (z.B. beim Badge-Zaehler in ConsultantComponent).
let localesRegistered = false;
let labelToCodeCache: Record<string, string> | null = null;

function ensureLocales(): void {
  if (localesRegistered) return;
  nationalities.registerLocale(deNationalityLocale);
  nationalities.registerLocale(enNationalityLocale);
  localesRegistered = true;
  labelToCodeCache = null;
}

function getLabelToCode(): Record<string, string> {
  ensureLocales();
  if (labelToCodeCache) return labelToCodeCache;
  const map: Record<string, string> = {};
  for (const lang of nationalities.langs()) {
    const allNames = nationalities.getNames(lang);
    for (const [code, label] of Object.entries(allNames)) {
      map[(label as string).toLowerCase()] = code;
    }
  }
  labelToCodeCache = map;
  return map;
}

/** True wenn der gespeicherte Wert einem ISO-3166-1-Alpha-2-Code oder einem bekannten Legacy-Label entspricht. */
export function isKnownNationality(storedValue: string | null | undefined): boolean {
  if (!storedValue || !storedValue.trim()) return false;
  ensureLocales();
  if (nationalities.getName(storedValue.toUpperCase(), 'de')) return true;
  return storedValue.toLowerCase() in getLabelToCode();
}
